import Chapter from '../Chapter';
import Caption from './caption/Caption';

export type ChapterPageContent = {
    x: number;
    y: number;
    width: number;
    text: string;
};

export default class TextPanel extends Phaser.GameObjects.Container {
    private tapper!: Phaser.GameObjects.Rectangle;
    private captions: Caption[] = [];
    private captionsDone: Caption[] = [];
    private currentCaption: Caption | null = null;
    private tapperFinalizePage: boolean = false;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);
        this.setupTapper();
    }

    private setupTapper(): void {
        this.tapper = this.scene.add.rectangle(
            0,
            0,
            this.scene.cameras.main.width,
            this.scene.cameras.main.height,
            0xffffff,
            0
        );
        this.add(this.tapper);

        this.tapper.setInteractive();
        this.tapper.on('pointerdown', this.onTapperClick, this);
    }

    private onTapperClick(): void {
        this.currentCaption?.finishTyping();

        if (this.captions.length === 0 && !this.tapperFinalizePage) {
            this.tapperFinalizePage = true;
            this.tapper.once('pointerdown', this.onTapperClickFinalizePage, this);
        }
    }

    private onTapperClickFinalizePage(): void {
        this.tapperFinalizePage = false;
        this.scene.events.emit('CHAPTER_MOVE_RIGHT_OR_CLOSE', Chapter.DIRECTIONS.LEFT);
    }

    public async showCaptions(data: ChapterPageContent[]): Promise<void> {
        if (!data || data.length == 0) return

        for (const { x, y, width, text } of data) {
            const caption = new Caption(this.scene, x, y, width, text);
            this.add(caption);
            this.captions.push(caption);
        }

        while (this.captions.length > 0) {
            const nextCaption = this.captions.shift();
            if (!nextCaption) {
                break;
            }
            this.currentCaption = nextCaption;
            this.captionsDone.push(this.currentCaption);
            await this.currentCaption.show();
            await this.currentCaption.start();
        }
    }

    public dispose(): void {
        for (const caption of this.captionsDone) caption.dispose();
        for (const caption of this.captions) caption.dispose();
        while (this.captions.length > 0) this.captions.pop()?.destroy();
        while (this.captionsDone.length > 0) this.captionsDone.pop()?.destroy();
        this.captions = [];
        this.captionsDone = [];
    }
}
